<template lang="pug">
el-select(
  :class="{'fix-width': fixWidth}"
  v-model="localValue"
  @change="changeValue"
  :clearable="clearable"
  :disabled="disabled"
  :multiple="multiple"
  filterable
  )
  el-option(
    v-for="branch in branches"
    :key="branch.id"
    :label="branchLabel(branch)"
    :value="branch.id")
</template>

<script>
import { getBranches } from '@/api/place';

export default {
  props: {
    value: {
      type: [Number, String, Array],
      default: undefined,
    },
    showAll: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    fixWidth: {
      type: Boolean,
      default: false,
    },
    // 是否一併列出非公開館別（標示「（非公開）」，排在公開館別之後）
    includeNonPublic: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
  },
  data() {
    return {
      branches: [],
      localValue: undefined,
    };
  },
  computed: {
    disabled() {
      return this.branches.filter((b) => b.id !== '').length <= 1;
    },
  },
  methods: {
    async loadData() {
      let branches;
      if (this.includeNonPublic) {
        const all = await getBranches();
        const isPublic = (b) => b.public || b.public === undefined;
        branches = [...all.filter(isPublic), ...all.filter((b) => !isPublic(b))];
      } else {
        branches = (await getBranches(true)).filter((b) => b.public || b.public === undefined);
      }
      if (this.showAll) {
        branches.unshift({
          id: undefined,
          name: '全部館別',
        });
      }
      this.branches = branches;
      if (!this.showAll && !this.multiple && this.localValue === undefined) {
        this.localValue = this.branches.filter((b) => b.id !== '')[0]?.id;
        this.$emit('input', this.localValue);
      }
    },
    branchLabel(branch) {
      if (this.includeNonPublic && branch.public === false) {
        return `${branch.name}（非公開）`;
      }
      return branch.name;
    },
    changeValue() {
      if (!this.localValue) {
        this.$emit('input');
      } else {
        this.$emit('input', this.localValue);
      }
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.fix-width {
  width: 120px;
  flex: 0 0 120px;
}
</style>
